<template>
  <div class="request-form">
    <div class="container">
      <div class="form-wrapper">
        <!-- Back Link -->
        <router-link to="/privacy-policy" class="back-link">← Back</router-link>
        
        <!-- Privacy Header -->
        <div class="privacy-header">
          <h4 class="title">Your Privacy Matters to Us</h4>
          <p class="privacy-text">
            We prioritize the confidentiality and security of your personal data. 
            Rest assured, your information is handled with the utmost care and in 
            accordance with applicable data protection laws.
          </p>
          <p class="privacy-text">
            If you wish to request the deletion of your data from our systems, 
            please complete the form below:
          </p>
        </div>

        <hr class="divider">

        <!-- Form Section -->
        <div class="form-section">
          <h4 class="form-title">Data Deletion Request Form</h4>
          
          <form @submit.prevent="submit_form">
            <div class="form-group">
              <label for="fullname">Fullname *</label>
              <input 
                id="fullname"
                class="form-control" 
                type="text" 
                v-model="fullname" 
                placeholder="Enter your fullname"
                required
              >
            </div>

            <div class="form-group">
              <label for="email">Email *</label>
              <input 
                id="email"
                class="form-control" 
                type="email" 
                v-model="email_address" 
                placeholder="Enter email address"
                required
              >
            </div>

            <div class="form-group">
              <label for="message">Message *</label>
              <textarea 
                id="message"
                class="form-control" 
                v-model="message" 
                cols="30" 
                rows="4" 
                placeholder="Tell us why you want us to delete your account from our database"
                required
              ></textarea>
            </div>

            <div class="form-actions">
              <button 
                type="submit" 
                class="btn btn-submit" 
                :disabled="isSubmitButtonDisabled || loading"
              >
                <span v-if="!loading">Submit Request</span>
                <span v-if="loading" class="spinner">
                  <span class="spinner-border spinner-border-sm" role="status"></span>
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import $ from 'jquery';

export default {
  data() {
    return {
      logo_url: process.env.VUE_APP_API_LOGO,
      company_phone: '',
      company_email: '',
      company_name: '',
      company_address: '',
      loading: false,
      fullname: '',
      email_address: '',
      phone_number: '',
      message: '',
      request_message: '',
    };
  },

  mounted() {
    $(document).ready(function() {
      $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
          $('.top').fadeIn();
          document.getElementById('top-header').style.display = 'none';
        } else {
          $('.top').fadeOut();
          if ($(this).scrollTop() == 0) {
            document.getElementById('top-header').style.display = 'flex';
          }
        }
      });

      $('.top').click(function() {
        $('html, body').animate({scrollTop: 0}, 800);
        return false;
      });
    });

    document.title = "Data Deletion Request";
    this.config_data();
  },

  computed: {
    isSubmitButtonDisabled() {
      return (
        this.fullname.trim() === '' ||
        this.email_address.trim() === '' ||
        this.message.trim() === '' 
      );
    }
  },

  methods: {
    async submit_form() {
      try {
        this.loading = true;
        const response = await this.$http.post('/request-message', {
          fullname: this.fullname,
          email_address: this.email_address,
          message: this.message
        });

        this.loading = false;

        if (!response.data.success) {
          swal.fire({
            icon: 'error',
            title: 'Error',
            width: 450,
            text: response.data.message,
          });
          return;
        }

        swal.fire({
          icon: 'success',
          title: 'Successful',
          width: 450,
          text: response.data.message,
        });

        // Reset form
        this.fullname = '';
        this.email_address = '';
        this.message = '';

      } catch (err) {
        console.error(err);
        this.loading = false;
        swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An unexpected error occurred. Please try again.',
        });
      }
    },

    async config_data() {
      try {
        const response = await fetch('/config.json');
        const configData = await response.json();
        this.company_phone = configData.phoneNumber;
        this.company_email = configData.emailAddress;
        this.company_address = configData.address;
        this.request_message = configData.requestMessage;
      } catch (error) {
        console.error('Failed to load config:', error);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Mulish:wght@300;400;500;700&display=swap');

.request-form {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem;
  background: #fff;
  font-family: 'Mulish', sans-serif;
}

.container {
  width: 100%;
  max-width: 600px;
}

.form-wrapper {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.back-link {
  display: inline-block;
  margin-bottom: 1rem;
  color: #3498db;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  
  &:hover {
    text-decoration: underline;
  }
}

.privacy-header {
  margin-bottom: 1.5rem;
  
  .title {
    font-weight: 500;
    color: #2c3e50;
    margin-bottom: 1rem;
  }
  
  .privacy-text {
    font-size: 14px;
    line-height: 1.6;
    color: #555;
    margin-bottom: 0.8rem;
  }
}

.divider {
  border: none;
  border-top: 1px solid #eee;
  margin: 1.5rem 0;
}

.form-section {
  .form-title {
    font-weight: 500;
    color: #2c3e50;
    margin-bottom: 1.5rem;
  }
}

.form-group {
  margin-bottom: 1.5rem;
  
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 14px;
    font-weight: 500;
    color: #555;
  }
  
  .form-control {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.3s;
    
    &:focus {
      outline: none;
      border-color: #3498db;
      box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
    }
  }
  
  textarea.form-control {
    resize: vertical;
    min-height: 120px;
  }
}

.form-actions {
  margin-top: 2rem;
  
  .btn-submit {
    width: 100%;
    padding: 0.75rem;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s;
    
    &:hover:not(:disabled) {
      background-color: #218838;
    }
    
    &:disabled {
      opacity: 0.65;
      cursor: not-allowed;
    }
  }
}

.spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .request-form {
    padding: 1rem;
  }
  
  .form-wrapper {
    padding: 1.5rem;
  }
}
</style>